import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
} from "@mui/material";

import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";


const ConfirmarEliminar = ({
    open,
    onClose,
    onConfirm,
    loading,
    banner,
}) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}

            maxWidth="xs"
            fullWidth
        >

            <DialogContent
                sx={{
                    textAlign: "center",

                    pt: 4,
                    pb: 2,
                }}
            >

                <Box
                    sx={{
                        width: 64,
                        height: 64,

                        mx: "auto",
                        mb: 2,

                        borderRadius: "50%",

                        display: "flex",

                        alignItems:
                            "center",

                        justifyContent:
                            "center",

                        background:
                            "#fff1f1",

                        color:
                            "#C62828",
                    }}
                >

                    <WarningAmberRoundedIcon
                        fontSize="large"
                    />

                </Box>


                <DialogTitle
                    sx={{
                        p: 0,

                        fontWeight: 800,

                        color:
                            "#12213F",
                    }}
                >
                    ¿Eliminar banner?
                </DialogTitle>


                <Typography
                    sx={{
                        mt: 1.5,

                        color:
                            "#687083",

                        lineHeight: 1.6,
                    }}
                >

                    ¿Estás seguro de que deseas
                    eliminar este banner?

                </Typography>


                {banner?.titulo && (

                    <Typography
                        sx={{
                            mt: 2,

                            fontWeight: 700,

                            color:
                                "#484a75",
                        }}
                    >
                        "{banner.titulo}"
                    </Typography>

                )}


                <Typography
                    sx={{
                        mt: 2,

                        fontSize: ".85rem",

                        color:
                            "#9a9fac",
                    }}
                >
                    Esta acción no se puede
                    deshacer.
                </Typography>

            </DialogContent>


            <DialogActions
                sx={{
                    px: 3,
                    pb: 3,

                    justifyContent:
                        "center",

                    gap: 1,
                }}
            >

                <Button
                    onClick={onClose}

                    sx={{
                        borderRadius:
                            "12px",

                        textTransform:
                            "none",

                        fontWeight: 700,

                        color:
                            "#687083",
                    }}
                >
                    Cancelar
                </Button>


                <Button
                    onClick={onConfirm}

                    disabled={loading}

                    variant="contained"

                    sx={{
                        borderRadius:
                            "12px",

                        textTransform:
                            "none",

                        fontWeight: 700,

                        background:
                            "#C62828",

                        boxShadow: "none",

                        "&:hover": {
                            background:
                                "#a51f1f",
                            boxShadow: "none",
                        },
                    }}
                >

                    {loading
                        ? "Eliminando..."
                        : "Sí, eliminar"}

                </Button>

            </DialogActions>

        </Dialog>

    );
};


export default ConfirmarEliminar;